<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4 mb-5" style="max-width:560px">
        <h3>Fiken firmaer</h3>

        <div v-show="!loading">
            <div v-if="locations.length === 0" class="mt-4">
              <span class="message-info">Ingen avdelinger har Fiken aktivert. Aktiver det under Avdelinger.</span>
            </div>

            <div v-else-if="!configured" class="mt-4">
              <span class="message-info">Fiken-konto er ikke konfigurert for denne avdelingen. Gå til <a href="/fiken">Fiken innstillinger</a> for å sette opp.</span>
            </div>

            <div v-if="configured">
                <div v-if="hasMultiLocations()" class="mt-4">
                  <span class="ingredient-title">Velg avdeling</span>
                  <select class="form-select" v-model="locationId" @change="onLocationChange()">
                    <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
                  </select>
                </div>

                <div class="mt-4">
                  <p class="text-muted">Viser firmaer tilgjengelig i Fiken-kontoen. CompanySlug brukes for API-kall.</p>
                  <button type="button" class="bo_btn mt-2" @click="loadCompanies"> Hent firmaer </button>

                  <div v-if="companiesLoaded" class="mt-3">
                    <div v-if="companies.length === 0" class="message-info">
                      <p>Ingen firmaer funnet i Fiken-kontoen.</p>
                    </div>

                    <div v-else>
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>Navn</th>
                            <th>Slug</th>
                            <th>Org.nr</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(company, index) in companies" :key="index">
                            <td>{{ company.name }}</td>
                            <td>{{ company.slug }}</td>
                            <td>{{ company.organizationNumber }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="errorMessage" class="mt-3 message-error">
                    <p>{{ errorMessage }}</p>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SettingsService from "@/services/settings/SettingsService";
  import LocationUtil from "@/util/LocationUtil";
  import LocationService from "@/services/location/LocationService";

  export default {
    components: {LoadingSpinner},
    data() {
      return {
        loading: true,
        locationId: '',
        locations: [],
        configured: false,
        companiesLoaded: false,
        companies: [],
        errorMessage: ''
      };
    },
    mounted() {
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data.filter(l => l.accountingSystem === 'FIKEN');
            this.locationId = this.locations.length ? this.locations[0].id : '';

            if (this.locationId) {
              this.checkAccountConfigured();
            } else {
              this.configured = false;
              this.loading = false;
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      onLocationChange(){
        this.companiesLoaded = false;
        this.companies = [];
        this.errorMessage = '';
        this.checkAccountConfigured();
      },
      checkAccountConfigured(){
        SettingsService.getFikenAccount(this.locationId).then(
            (response) => {
              if(response.data !== null){
                this.configured = !!(response.data.clientId && response.data.clientSecret);
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      },
      loadCompanies(){
        this.loading = true;
        this.companiesLoaded = false;
        this.errorMessage = '';

        SettingsService.getFikenCompanies(this.locationId).then(
            (response) => {
              this.companiesLoaded = true;
              this.companies = response.data || [];
              this.loading = false;
            },
            (error) => {
              this.companiesLoaded = false;
              this.errorMessage = 'Feil ved henting av firmaer fra Fiken';
              console.log(error);
              this.loading = false;
            }
        );
      }
    }
  };
</script>
